import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';

import { LanguageDetectionService } from './language-detection.service';

export function provideLanguageDetection(): (Provider | EnvironmentProviders)[] {
  return [provideEnvironmentInitializer(() => inject(LanguageDetectionService))];
}
